<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormEmergency8 }}</h2>

        <div class="mb-3">
            {{ store.lexicon[store.culture].PRPolice2 }}
        </div>

        <label>{{ store.lexicon[store.culture].PRFormEmergency7 }}<span class="required">*</span></label>
        <div class="row">
            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck7" v-model="store.formData.Emergency.Types" value="Computer Aided Dispatch (CAD) Report" @change="validatePage('Emergency', 'types')">
                    <label class="custom-control-label" for="customCheck7">{{ store.lexicon[store.culture].PRFormEmergency8a }}</label>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck8" v-model="store.formData.Emergency.Types" value="Airport Communications Telephone" @change="validatePage('Emergency', 'types')">
                    <label class="custom-control-label" for="customCheck8">{{ store.lexicon[store.culture].PRFormEmergency9 }}</label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck9" v-model="store.formData.Emergency.Types" value="Police Radio Audio" @change="validatePage('Emergency', 'types')">
                    <label class="custom-control-label" for="customCheck9">{{ store.lexicon[store.culture].PRFormEmergency10 }}</label>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="customCheck10" v-model="store.formData.Emergency.Types" value="Fire Radio Audio" @change="validatePage('Emergency', 'types')">
                    <label class="custom-control-label" for="customCheck10">{{ store.lexicon[store.culture].PRFormEmergency11 }}</label>
                </div>
            </div>
        </div>

        <div v-if="store.errors.Emergency.Types" class="error mb-3">{{ store.lexicon[store.culture].PRFormRequestType11 }}</div>

        <div class="row">
            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormEmergency13 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Emergency.IncidentDateTime" @input="validatePage('Emergency', 'incidentDateTime')" />
                <div v-if="store.errors.Emergency.IncidentDateTime" class="error">{{ store.lexicon[store.culture].PRFormEmergency14 }}</div>
            </div>

            <div class="form-group col-sm-6">
                <label>{{ store.lexicon[store.culture].PRFormEmergency15 }} <span class="required">*</span></label>
                <input type="text" class="form-control" v-model="store.formData.Emergency.IncidentRelationship" @input="validatePage('Emergency', 'incidentRelationship')" />
                <div v-if="store.errors.Emergency.IncidentRelationship" class="error">{{ store.lexicon[store.culture].PRFormEmergency16 }}</div>
            </div>
        </div>

        <div class="form-group">
            <label>{{ store.lexicon[store.culture].PRFormEmergency17 }} <span class="required">*</span></label>
            <textarea type="text" class="form-control" v-model="store.formData.Emergency.Details" @input="validatePage('Emergency', 'details')"></textarea>
            <div v-if="store.errors.Emergency.Details" class="error">{{ store.lexicon[store.culture].PRFormEmergency18 }}</div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.currentTypePage == 0 ? goBackToPage('TYPE') : goBackToTypePage(store.currentTypePage - 1)">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="store.currentTypePage == store.formData.Types.length - 1 ? goToPage('FINISH') : goToTypePage(store.currentTypePage + 1)">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'goToTypePage', 'goBackToTypePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goToTypePage(index) {
        emit('goToTypePage', index);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }


</script>